  <template>
  <div class="is-line-left-solid yk-interactions__container__share yk-interactions__container__share-last-new">
    <div class="yk-interactions--header"
         style="padding-right:0px;">
      <span class="interaction-tips">问卷调查</span>      
      <!-- <el-button @click="auditingActivity" size="small" v-if="userType==0">审核</el-button> -->
      <el-input placeholder="请输入名称查询"
                v-model="paperName"
                @keyup.enter.native='GetFaceTeachActivityList'>
        <i slot="suffix"
           class="el-input__icon el-icon-search"
           @click="GetFaceTeachActivityList()"></i>
      </el-input>
    </div>
    <div class="yk-class-activity-add-btn-wrapper"
         @click="questionair()">
      <i class="wl-icon-tianjia1"></i>
      <span style="color:black;">新增问卷调查</span>
    </div>
    <div class="yt-interactions-line-division"></div> 
    <div class="yk-interactions--inner"
         v-show="totalCount>0">
      <el-table ref="multipleTable"
                :data="list"
                stripe
                tooltip-effect="dark"
                style="width: 100%"
                empty-text=" ">
        <el-table-column label="序号"
                         type="index"
                         width="60">
        </el-table-column>
        <el-table-column prop="activityName"
                         label="名称">
        </el-table-column>
        <el-table-column prop="CreateDisplayName"
                         label="创建人">
        </el-table-column>
        <!-- <el-table-column prop="IsAuditing"
                         label="审核状态"
                         width="150">
        </el-table-column> -->
        <el-table-column label="操作"
                         width="180px">
          <template slot-scope="scope">
            <div class="yk-tem-button">
               <!-- <router-link :to="scope.row.id+'/ShareSurveyCourseView'"> -->
                <!-- <el-button size="mini"
                          @click="view(scope.row.id)"
                           icon="el-icon-view"
                           type="primary"
                           title="详情"
                           style="margin-right:10px"></el-button> -->
              <!-- </router-link> -->
              <!-- <router-link :to="'ShareQuestionnaireQuestion/'+scope.row.id">
                <el-button size="mini"
                           @click="editActivity(scope.row)"
                           icon="el-icon-view"
                           type="primary"
                           title="详情"
                           style="margin-right:10px"></el-button>
              </router-link> -->
              <router-link :to="'teaShareQuestionnaireQuestion/' + scope.row.id">
                <el-button size="mini"
                           icon="el-icon-edit"
                           type="primary"
                           title="编辑"
                           style="margin-right:10px"></el-button>
              </router-link>
              <el-button size="mini"
                         @click="deleteActivity(scope.row.id)"
                         icon="el-icon-delete"
                         type="danger"
                         title="删除"></el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-show="noDataShow"
         class="yk-nodata-source-content">
      <img src="~assets/images/the-last-new-nodata-imag.png"
           alt=""
           class="yk-prompt">
      <div class="sp-noData">暂无内容，请新增问卷调查。</div>
    </div>
    <div>
    <el-pagination background
                   @size-change="handleSizeChange"
                   @current-change="onPageChangeHandler"
                   :current-page="pageIndex"
                   :page-sizes="[5 , 10, 15, 20]"
                   :page-size="pageSize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="totalCount"
                   v-show="totalCount>0">
    </el-pagination>
    </div>

    <!-- 弹窗（签到、提问、问卷调查） -->
    <el-dialog :before-close="handleClose"
               title="问卷调查"
               :visible.sync="dialogFormVisibleSignOrQuestion"
               :append-to-body="true"
               :close-on-click-modal="false"
               :close-on-press-escape="false">
      <el-form label-width="82px">
        <el-form-item label="名称：">
          <el-input v-model="activityName"
                    class="input-with-select"
                    :disabled="true"></el-input>
        </el-form-item>

        <div>
          <el-form-item label="内容：">
            <el-input type="textarea"
                      :rows="3"
                      resize='none'
                      class="input-with-select"
                      v-model="activityContent"
                      :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="类型：">
            <el-radio-group v-model="questionType">
              <el-radio label=1>摇一摇</el-radio>
              <el-radio label=2>手选</el-radio>
              <el-radio label=3>抢答</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>

      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="cancel()">取 消</el-button>
        <el-button type="primary"
                   @click="cancel()"
                   :disabled="disabled">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  getSchoolActivityList,
  AddSchoolActivity,
  DeleteSchoolActivity,
  EditSchoolActivity
} from 'api/v1.manager.schoolactivity';
export default {
  props: {
    schoolCourseId: {
      type: String,
      default: ''
    },
    courseId: {
      type: String,
      default: ''
    },
    userType: {
      type: [String,Number],
      default: 0
    }
  },
  data() {
    return {
      // newCourseId: this.$route.params.courseId,
      /** 分页 */
      totalCount: -1,
      pageSize: 10,
      pageIndex: 1,
      /** 查询条件 */
      paperType: '3',
      /** 返回列表 */
      list: [],
      addName: '',
      /** */
      /* 颜色改变 */
      active: 1,
      menuShow: false,
      dialogFormVisibleSignOrQuestion: false,
      activityName: '',
      activityContent: '',
      ActivityRemake: '',
      activityType: 7,
        urlAliyunOSS: '/api/design/osssign/getsign',
      docJson: '',
      disabled: false,
      dataJson: [
        { name: 'A', content: '' },
        { name: 'B', content: '' },
        { name: 'C', content: '' }
      ],
      activityId: '',
      activityRemake: '',
      voteType: '正确错误',
      questionType: 1,
      routers: '/question',
      paperName: '',
      loadingShow: false,
      noDataShow: false,
      ids: [],
      word: ''
    };
  },
  created() {
    this.GetFaceTeachActivityList(1);
  },
  computed: {
    auth() {
      let auth = this.$store.state.auth;
      return { ...auth };
    }
  },
  methods: {
    /** 返回列表 */
    GetFaceTeachActivityList(page) {
      this.loadingShow = true;
      getSchoolActivityList(
        this.schoolCourseId,
        this.courseId,
        7,
        this.paperName,
        page,
        this.pageSize
      ).then(rst => {
        this.list = rst.list;
        this.loadingShow = false;
        if (this.list.length == 0) {
          this.noDataShow = true;
        } else {
          this.noDataShow = false;
        }
        this.totalCount = rst.pagination.totalCount;
        this.pageSize = rst.pagination.pageSize;
        this.pageIndex = rst.pagination.pageIndex;
      });
    },
    handleClose: function() {
      this.dialogVisible = false;
    },
    handleClose(done) {
      done();
      this.cancel();
    },
    // 新增弹框
    questionair() {
      this.$router.push({
        name: 'teaShareQuestionnaireQuestion',
        params: {
          schoolCourseId: this.schoolCourseId,
          questionnaireId: '0',
          courseId: this.courseId,
          userType: this.userType
        }
      });
    },
    // 新增/编辑判断
    addoredit() {
      if (this.activityId == '') {
        this.disabled = true;
        this.AddFaceTeachActivity();
      } else {
        this.disabled = true;
        this.EditFaceTeachActivity();
      }
    },
    // 添加活动
    AddFaceTeachActivity() {
      var dataJson = JSON.stringify(this.dataJson);
      var voteType = 0;
      if (this.activityContent == '') {
        this.activityContent = '暂无内容';
      }
      if (this.voteType == '正确错误') voteType = 1;
      else if (this.voteType == '赞成反对') voteType = 2;
      else if (this.voteType == '单选') voteType = 3;
      else if (this.voteType == '多选') voteType = 4;

      if (this.activityType == 6 && this.activityContent == '') {
        this.$message.warning('投票内容不能为空');
        this.disabled = false;
        return false;
      }
      if (this.activityType == 6 && this.voteType == 0) {
        this.$message.warning('投票类型不能为空');
        this.disabled = false;
        return false;
      }
      if (
        (this.voteType == 3 || this.voteType == 4) &&
        this.dataJson.length == 0
      ) {
        this.$message.warning('投票选项不能未空');
        this.disabled = false;
      }
      AddSchoolActivity(
        this.schoolCourseId,
        this.CourseId,
        this.activityName,
        this.activityContent,
        this.voteType,
        dataJson,
        this.activityType,
        this.ActivityRemake,
        this.docJson,
        (this.questionType = 0),
        this.userType
      ).then(rst => {
        this.$message({
          type: 'warning',
          message: rst.msg
        });
        if (rst.code > 0) {
          this.cancel();
          this.GetFaceTeachActivityList();
        }
      });
    },
    // 编辑活动
    EditFaceTeachActivity() {
      var dataJson = JSON.stringify(this.dataJson);
      var voteType = 0;
      if (this.activityContent == '') {
        this.activityContent = '暂无内容';
      }
      if (this.voteType == '正确错误') voteType = 1;
      else if (this.voteType == '赞成反对') voteType = 2;
      else if (this.voteType == '单选') voteType = 3;
      else if (this.voteType == '多选') voteType = 4;
      EditSchoolActivity(
        this.activityId,
        this.activityName,
        this.activityContent,
        this.ActivityRemake,
        (this.questionType = 0),
        this.voteType,
        dataJson,
        this.docJson
      ).then(rst => {
        this.$message({
          type: 'warning',
          message: rst.msg
        });
        if (rst.code > 0) {
          this.activityId = '';
          this.cancel();
          this.GetFaceTeachActivityList(this.pageIndex);
          this.disabled = false;
        }
      });
    },
    // 打开编辑活动弹窗
    editActivity(row) {
      this.disabled = false;
      this.activityId = row.id;
      this.activityType == 7;
      this.activityName = row.activityName;
      this.activityContent = row.activityContent;
      this.voteType = row.voteType;
      this.docJson = row.docJson;
      this.dataJson =
        row.dataJson == '' ? this.dataJson : eval('(' + row.dataJson + ')');
      this.activityRemake = row.activityRemake;
      this.dialogFormVisibleSignOrQuestion = true;
    },
    onPageChangeHandler(page) {
      this.GetFaceTeachActivityList(page);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetFaceTeachActivityList(1);
    },
    // 删除活动
    deleteActivity(id) {
      this.$confirm('此操作将删除当前活动, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 删除班级
          DeleteSchoolActivity(id).then(rst => {
            this.$message.warning(rst.msg);
            this.GetFaceTeachActivityList(this.pageIndex);
          });
        })
        .catch(() => {
          this.$message.info('已取消删除');
        });
    },
    changeMenu: function() {
      this.menuShow = !this.menuShow;
    },
    // 获取当前时间方法
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = '-';
      var seperator2 = ':';
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = '0' + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate;
      }
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        ' ' +
        date.getHours() +
        seperator2 +
        date.getMinutes() +
        seperator2 +
        date.getSeconds();
      return currentdate;
    },
    // 取消弹窗方法
    cancel() {
      this.activityId = '';
      this.activityName = '';
      this.activityContent = '';
      (this.questionType = 1),
      (this.voteType = '正确错误'),
      (this.paperId = '');
      this.dataJson = [
        { name: 'A', content: '' },
        { name: 'B', content: '' },
        { name: 'C', content: '' }
      ];
      this.dialogFormVisibleSign = false;
      this.dialogFormVisibleSignOrQuestion = false;
      this.dialogFormVisiblePaper = false;
      this.docJson = '';
    },
    view(id) {
      this.$router.push({
        name: 'ShareSurveyCourseView',
        params: {
          courseId: this.courseId,
          questionnaireId: id,
        }
      });
    }
  }
};
</script>

<style lang="scss">
.yk-interactions__container__share {
  .yk-interactions--header {
    .yk-sourse--nemu-btn-wrapper-pre-dis {
      float: right;
      margin-left: 10px;
      width: 90px;
      height: 32px;
      background: rgba(63, 162, 255, 1);
      border-radius: 3px;
      line-height: 32px;
      text-align: center;
      color: #fff;
    }
  }
  .yk-class-activity-add-btn-wrapper {
    padding: 10px;
    margin-top: 20px;
    text-align: center;
    font-size: 17px;
    /* color: #fff; */
    border-radius: 10px;
    border: 1px dashed black;
    cursor: pointer;
    .wl-icon-tianjia1 {
      margin-right: 10px;
      font-size: 25px;
      border-radius: 50%;
      color:black;
      border: 1px solid black;
      vertical-align: -2px;
    }
  }
}
.yk-interactions__container__share-last-new {
  .yk-btn-new-back-s {
    position: fixed;
    right: 30px;
    top: 10px;
    z-index: 2000;
    padding: 2px 10px;
    .wl-icon-fanhui2 {
      font-size: 29px;
    }
  }
  .el-input__inner {
    height: 32px;
  }
  .el-pagination__total {
    margin-right: 10px;
    font-weight: 400;
    //color: #fff;
  }
  .el-pagination__jump {
    margin-left: 24px;
    font-weight: 400;
    //color: #fff;
  }
}
</style>